import React from 'react';
import { motion } from 'framer-motion';
export type Testimonial = {
  name: string;
  role: string;
  avatar: string;
  quote: string;
};
/** Role-relevant social proof strip for use-case pages. Sits between the
 *  comparison rows and the cross-links/CTA so visitors see people like them
 *  vouching for Giga right before the conversion moment. */
export function UseCaseTestimonials({
  testimonials
}: {
  testimonials: Testimonial[];
}) {
  return <section className="w-full bg-[#FAF8F4] py-20 md:py-28" data-id="element-3077">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-3078">
        <div className="text-center mb-12 md:mb-16" data-id="element-3079">
          <span className="text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-4 block" data-id="element-3080">
            From people in your seat
          </span>
          <h2 className="font-title font-bold text-3xl md:text-4xl tracking-tight text-[#2B211A]" data-id="element-3081">
            Don't take our word for it
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-3082">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="flex flex-col bg-white rounded-2xl border border-neutral-200 shadow-sm p-6 md:p-8" data-id="element-3083">
              <blockquote className="flex-1 text-[15px] text-neutral-700 leading-relaxed" data-id="element-3084">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-neutral-100 flex items-center gap-3" data-id="element-3085">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover grayscale" data-id="element-3086" />
                <div data-id="element-3087">
                  <div className="font-bold text-[#2B211A] text-sm" data-id="element-3088">
                    {t.name}
                  </div>
                  <div className="text-xs text-neutral-500" data-id="element-3089">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}